export default __webpack_public_path__ + "static/media/maranata_1.e5c45d55.jpg";